/**
 * Check if a locator is either a custom locator or a git locator for a
 * repository on Github.
 */
export default function isCustomAndGithubLocator(locator: string): boolean {
  return /^custom\+[0-9]+\/(?:git@)?github.com/ig.test(locator);
}
